import type {Root} from 'hast'
import type {Schema} from 'hast-util-sanitize'
import {visit} from 'unist-util-visit'

import {isTag} from '../hast-utils'

/** The presence of this prop indicates that a link *might* be an embedded video. */
export const videoCandidateProp = 'dataVideoCandidate'

export function identifyVideoLinks(tree: Root): void {
  visit(tree, 'element', (node, index, parent) => {
    if (!parent || typeof index !== 'number') return
    if (!isTag(node, 'p')) return

    // Video links must be the only meaningful child of a paragraph (allow whitespace-only text nodes)
    const meaningfulChildren = node.children.filter(
      c => c.type === 'element' || (c.type === 'text' && c.value.trim() !== ''),
    )
    if (meaningfulChildren.length !== 1) return
    const child = meaningfulChildren[0]
    if (child?.type !== 'element' || !isTag(child, 'a')) return

    child.properties[videoCandidateProp] = true
  })
}

export const videoLinksSanitizeSchema: Schema = {
  attributes: {
    ['*']: [videoCandidateProp],
  },
}
